module.exports = __webpack_public_path__ + "assets/img/gift.c01480db.jpg";